import { useTranslation } from '@hooks/useTranslation';
import { getScalesWithLabel } from './scalesWithOptions';

const BADGE_BASE = 'inline-flex items-center justify-center rounded-[5px] border border-dinnerplate-white font-inter font-normal text-off-black whitespace-nowrap';
const BADGE_SIZE_COMPACT = 'px-1.5 py-0.5 text-xs';
const BADGE_SIZE_REGULAR = 'px-1.5 py-1 text-sm';

const CONTAINER_SIZE_COMPACT = 'text-xs';
const CONTAINER_SIZE_REGULAR = 'text-sm';

interface ConfigurationSummaryProps {
  defaultType?: string | null;
  quantity: number | null;
  value: number | null;
  multiplier?: string | null;
  inventoryName: string;
  size?: 'compact' | 'regular';
  formatNumber?: (n: number | null) => string;
}

export function ConfigurationSummary({
  defaultType,
  quantity,
  value,
  multiplier,
  inventoryName,
  size = 'regular',
  formatNumber = (n) => (n ?? 0).toFixed(1),
}: ConfigurationSummaryProps) {
  const { t } = useTranslation();

  if (defaultType === 'Static') return null;

  const badgeClass = `${BADGE_BASE} ${size === 'compact' ? BADGE_SIZE_COMPACT : BADGE_SIZE_REGULAR}`;
  const containerClass = `flex flex-wrap items-center gap-1.5 font-inter ${size === 'compact' ? CONTAINER_SIZE_COMPACT : CONTAINER_SIZE_REGULAR}`;

  const isComputed = defaultType === 'Computed';

  return (
    <div className={containerClass}>
      <span className={badgeClass}>{formatNumber(quantity)}</span>
      <span className={badgeClass}>{inventoryName}</span>
      <span className="text-grey">{t('common.default_inventory.summary_per')}</span>
      <span className={badgeClass}>{formatNumber(value)}</span>
      {isComputed ? (
        <span className={badgeClass}>{multiplier || '—'}</span>
      ) : (
        <>
          <span className={badgeClass}>{getScalesWithLabel(defaultType) || '—'}</span>
          {multiplier && (
            <>
              <span className="text-grey">{t('common.default_inventory.summary_multiplied_by')}</span>
              <span className={badgeClass}>{multiplier}</span>
            </>
          )}
        </>
      )}
    </div>
  );
}
